import {
  Checkbox,
  Flex,
  Select,
  Typography,
} from 'antd';
import React, { useState } from 'react';

function Togglable({
  title,
  children,
  defaultVisible = false,
  onVisibleChange,
  style,
  mode = 'checkbox', // 'checkbox' or 'select'
  showText = 'Show',
  hideText = 'Hide',
  ...props
}) {
  const [visible, setVisible] = useState(defaultVisible);
  const [selectValue, setSelectValue] = useState(defaultVisible);

  const handleCheckboxChange = (e) => {
    const newVisible = e.target.checked;
    setVisible(newVisible);
    if (onVisibleChange) {
      onVisibleChange(newVisible);
    }
  };

  const handleSelectChange = (value) => {
    setSelectValue(value);
    setVisible(value);
    if (onVisibleChange) {
      onVisibleChange(value);
    }
  };

  return (
    <Flex vertical gap={10}>
      {mode === 'checkbox' ? (
        <Checkbox checked={visible} onChange={handleCheckboxChange}>
          {title}
        </Checkbox>
      ) : (
        <Flex gap={10} vertical>
          <Typography.Text>{title}</Typography.Text>
          <Select
            value={selectValue}
            onChange={handleSelectChange}
            options={[
              { label: hideText, value: false },
              { label: showText, value: true },
            ]}
            style={{ minWidth: 120 }}
            size="large"
          />
        </Flex>
      )}
      <div className="ml-5" style={{ display: visible ? 'block' : 'none', ...style }} {...props}>
        {children}
      </div>
    </Flex>
  );
}

export default Togglable;
